import { hotspotACode, hotspotBCode, hotspotCCode, hotspotDCode, hotspotSelfcareACode, hotspotSelfcareBCode } from './hotspotsCode';
import { hotspotALayout, hotspotBLayout, hotspotCLayout, hotspotDLayout, hotspotSelfcareALayout, hotspotSelfcareBLayout } from './hotspotsLayouts';

import styles from './hotspotsSet.css';

const hotspotsSet = [
  {
    type: 'landings',
    previews: [
      {
        component: hotspotALayout,
        codeTemplate: hotspotACode,
        previewClassName: styles.typeAPreview,
        modalPreviewClassName: 'with-padding',
        optionsGroup: [
          {
            label: 'Type A',
            options: [
              {label: 'Version 1', type: 'radio', options: { bgColor: 'heavy-blue', version: 1, imagePath: 'hotspots/landing/typeAVersion1.png' }},
              {label: 'Version 2', type: 'radio', options: { bgColor: 'heavy-blue', version: 2, imagePath: 'hotspots/landing/typeAVersion2.png' }},
              {label: 'Version 3', type: 'radio', options: { bgColor: 'heavy-blue', version: 3, imagePath: 'hotspots/landing/typeAVersion3.png' }}
            ]
          }
        ]
      },
      {
        component: hotspotBLayout,
        codeTemplate: hotspotBCode,
        previewClassName: styles.typeBPreview,
        modalPreviewClassName: 'with-padding',
        optionsGroup: [
          {
            label: 'Type B',
            options: [
              {label: 'Version 1', type: 'radio', options: { bgColor: 'heavy-blue', version: 1, imagePath: 'hotspots/landing/typeBVersion1.png' }},
              {label: 'Version 2', type: 'radio', options: { bgColor: 'heavy-blue', version: 2, imagePath: 'hotspots/landing/typeBVersion2.png' }}
            ]
          }
        ]
      },
      {
        component: hotspotCLayout,
        codeTemplate: hotspotCCode,
        previewClassName: styles.typeCPreview,
        modalPreviewClassName: 'with-padding',
        optionsGroup: [
          {
            label: 'Type C',
            options: [
              {label: 'Version 1', type: 'radio', options: { bgColor: 'heavy-blue', version: 1, imagePath: 'hotspots/landing/typeCVersion1.png' }},
              {label: 'Version 2', type: 'radio', options: { bgColor: 'heavy-blue', version: 2, imagePath: 'hotspots/landing/typeCVersion2.png' }}
            ]
          }
        ]
      },
      {
        component: hotspotDLayout,
        codeTemplate: hotspotDCode,
        previewClassName: styles.typeDPreview,
        modalPreviewClassName: 'with-padding',
        optionsGroup: [
          {
            label: 'Type D',
            options: [
              {label: 'Version 1', type: 'radio', options: {bgColor: 'heavy-blue', imagePath: 'hotspots/landing/typeD.png'}},
            ]
          }
        ]
      }
    ]
  },
  {
    type: 'selfcare',
    previews: [
      {
        component: hotspotSelfcareALayout,
        codeTemplate: hotspotSelfcareACode,
        previewClassName: styles.selfcareTypeAPreview,
        modalPreviewClassName: 'with-padding',
        optionsGroup: [
          {
            label: 'Type A',
            options: [
              {label: 'Version 1', type: 'radio', options: { bgColor: 'heavy-blue', imagePath: 'hotspots/selfcare/typeA.png' }},
            ]
          }
        ]
      },
      {
        component: hotspotSelfcareBLayout,
        codeTemplate: hotspotSelfcareBCode,
        previewClassName: styles.selfcareTypeBPreview,
        modalPreviewClassName: 'with-padding',
        optionsGroup: [
          {
            label: 'Type B',
            options: [
              {label: 'Version 1', type: 'radio', options: { bgColor: 'heavy-blue', version: 1, imagePath: 'hotspots/selfcare/typeBVersion1.png' }},
              {label: 'Version 2', type: 'radio', options: { bgColor: 'heavy-blue', version: 2, imagePath: 'hotspots/selfcare/typeBVersion2.png' }},
            ]
          }
        ]
      }
    ]
  }
];

export { hotspotsSet };



// WEBPACK FOOTER //
// ./src/containers/components/Hotspots/constants/hotspotsSet.js